import { Provider } from 'react-redux';
import qs from 'qs';

import { store } from 'store/store';
import { SLOT_QUERY_PARAM_KEY, Slot, SlotQueryParamValues } from 'slots/types';
import ActionSlot from 'slots/ActionSlot';
import PostPaymentSlot from 'slots/PostPaymentSlot';
import SettingsSlot from 'slots/SettingsSlot';
import UISlot from 'slots/UISlot';

function getSlot(): Slot {
  const queryParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const slotQueryParam = queryParams[SLOT_QUERY_PARAM_KEY];

  switch (slotQueryParam) {
    case SlotQueryParamValues.ACTION:
      return Slot.ACTION;
    case SlotQueryParamValues.PAY:
      window.location.href = '/checkout';
      return Slot.PAY;
    case SlotQueryParamValues.POST_PAY:
      return Slot.POST_PAY;
    case SlotQueryParamValues.SETTINGS:
      return Slot.SETTINGS;
    default:
      return Slot.UI;
  }
}

const App = () => {
  const slot: Slot = getSlot();

  const getScreen = (slot: Slot) => {
    switch (slot) {
      case Slot.ACTION:
        return <ActionSlot />;

      case Slot.PAY:
        return <></>;

      case Slot.POST_PAY:
        return <PostPaymentSlot />;

      case Slot.SETTINGS:
        return (
          <Provider store={store}>
            <SettingsSlot />
          </Provider>
        );

      default:
        return (
          <Provider store={store}>
            <UISlot />
          </Provider>
        );
    }
  };

  return <div data-testid={`slot-${slot}`}>{getScreen(slot)}</div>;
};

export default App;
